/**
 * Downloads a chart as a PNG image
 * @param dataUrl - Base64 data URL from chart export
 * @param filename - Name for the downloaded file (without extension)
 */
export const downloadChartAsPng = (
  dataUrl: string | null,
  filename: string = 'chart'
): void => {
  if (!dataUrl) {
    console.warn('No chart data to download')
    return
  }

  const link = document.createElement('a')
  link.href = dataUrl
  link.download = `${filename}.png`
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}

/**
 * Sanitizes a filename by removing special characters
 * @param name - The original name
 * @returns A safe filename
 */
export const sanitizeFilename = (name: string): string => {
  return name
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-|-$/g, '')
}
